var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex mr-4"},[_c('div',{staticClass:"caption fw-normal text-xs-right"},[_vm._v("\n    "+_vm._s(_vm.copyrightText.replace('$$year$$', new Date().getFullYear()))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }